/** When your routing table is too long, you can split it into small modules**/


export default [{
        path: '/home-request-history',
        name: 'HomeRequestHistory',
        component: () =>
            import ('@/views/home-request/History'),
    }, {
        path: '/ejare-new',
        name: 'EjareNew',
        component: () =>
            import ('@/views/home-request/NewEjare'),
    },
    {
        path: '/buy-new',
        name: 'BuyNew',
        component: () =>
            import ('@/views/home-request/NewBuy'),
    },
    {
        path: '/home-request-active',
        name: 'HomeRequestActive',
        component: () =>
            import ('@/views/home-request/Active'),
    },
]